// extracted by mini-css-extract-plugin
export var container = "PromotionCard-module--container--543ca";
export var countdown = "PromotionCard-module--countdown--28918";
export var countdownItem = "PromotionCard-module--countdownItem--b4c17";
export var countdownLabel = "PromotionCard-module--countdownLabel--736c1";
export var countdownValue = "PromotionCard-module--countdownValue--17e80";
export var mobile = "PromotionCard-module--mobile--32c0e";
export var root = "PromotionCard-module--root--658c3";
export var subtitle = "PromotionCard-module--subtitle--cdffe";
export var title = "PromotionCard-module--title--dbcb0";